import { render, staticRenderFns } from "./ViewProfile.vue?vue&type=template&id=04e60026&scoped=true"
import script from "./ViewProfile.vue?vue&type=script&lang=js"
export * from "./ViewProfile.vue?vue&type=script&lang=js"
import style0 from "./ViewProfile.vue?vue&type=style&index=0&id=04e60026&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04e60026",
  null
  
)

export default component.exports